import { useState, useEffect } from 'react';
import { getHeadersUnwrapped, searchEmails, useUserContext } from '..';
import { compose as lcompose } from 'lodash/fp';

export const useEmailSearch = () => {
  const { user } = useUserContext();

  const [emailInput, setEmailInput] = useState('');
  const [options, setOptions] = useState<string[]>([]);

  useEffect(() => {
    lcompose(
      searchEmails,
      getHeadersUnwrapped
    )(user)(emailInput).then(setOptions);
  }, [emailInput, user]);

  return { emails: options, emailInput, setEmailInput };
};
